import { ButtonLink, PillDropdown } from '@toggle/design-system';
import styled from 'styled-components';

import { DrawerSectionHeader } from '~/views/theme-overview/theme-overview-drawer/components/drawer-section-header/DrawerSectionHeader';

import { CompanyItem } from './company-item/CompanyItem';

export const GridContainer = styled.li`
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  ${PillDropdown.Styled.StyledPillContainer} {
    justify-content: start;
    min-width: 116px;
    width: 100%;
  }

  ${PillDropdown.Styled.Label} {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  ${CompanyItem.Styled.AssetHeader} {
    width: calc(100% - 28px);
  }
`;

export const Root = styled.div`
  ${DrawerSectionHeader.Styled.Root} {
    padding-bottom: 4px;
  }
`;

export const CompanyItemWrapper = styled.div`
  width: 25%;
  border-bottom: 1px solid var(--border-soft);
  padding-top: 12px;
  padding-bottom: 4px;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
`;

export const StyledButtonLink = styled(ButtonLink)`
  margin-top: 12px;
`;
